export default {
    PRINT_DOCUMENT: "print_document",
    DOWN_PAYMENT: "down_payment",
}
